/* Bean Bros product page: section bar (sticky, active link, smooth jump), bar add-to-cart. Chat buttons are handled by the footer. */
(function () {
  var root = document.querySelector('[data-bb-pd]');
  if (!root) return;
  var bar = root.querySelector('[data-bb-pd-bar]');
  var links = [].slice.call(bar.querySelectorAll('.bb-pd__nav a'));
  // In bb-section-bar the bar is alone in its section, so the whole section is what sticks
  var stick = root.classList.contains('bb-pd--bar-only') ? (root.closest('.shopify-section') || bar) : bar;
  var sections = [].slice.call(root.querySelectorAll('[data-bb-pd-section]'));
  // Section bar on a template with its own sections (bb-section-bar): the links point at theme sections
  if (!sections.length) sections = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); }).filter(Boolean);
  var header = document.getElementById('SiteHeader');
  var variaBar = document.querySelector('[data-bb-varia-bar]');

  // On phones the section bar takes over from the Varia sub-bar once it is pinned,
  // so the screen isn't stacked with three bars.
  var mobile = window.matchMedia('(max-width: 768px)');
  var css = document.createElement('style');
  css.textContent = '@media (max-width:768px){html.bb-pd-stuck [data-bb-varia-bar]{visibility:hidden}}';
  document.head.appendChild(css);
  function pinned() { return mobile.matches ? [header] : [header, variaBar]; }

  // Bottom edge of whatever is pinned above the bar right now (sticky header, Varia sub-bar).
  function topOffset() {
    var t = 0;
    pinned().forEach(function (el) {
      if (!el) return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top >= -1 && r.top < 200) t = Math.max(t, r.bottom);
    });
    return Math.max(0, Math.round(t));
  }
  // What will be pinned once the page has scrolled, used when jumping.
  function pinnedHeight() {
    var h = 0;
    pinned().forEach(function (el) { if (el) h += el.offsetHeight; });
    return h + bar.offsetHeight;
  }

  var ticking = false, lockUntil = 0, lockId = null;
  function update() {
    ticking = false;
    var off = topOffset();
    stick.style.top = off + 'px';
    root.style.setProperty('--bb-pd-offset', (off + bar.offsetHeight + 12) + 'px');
    var line = off + bar.offsetHeight + 24;
    var current = null;
    sections.forEach(function (s) { if (s.getBoundingClientRect().top <= line) current = s.id; });
    if (Date.now() < lockUntil) current = lockId; // just clicked: keep that link lit while the page settles
    links.forEach(function (a) {
      var on = a.getAttribute('href') === '#' + current;
      a.classList.toggle('is-active', on);
      if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    var stuck = bar.getBoundingClientRect().top <= off + 1 && window.scrollY > 0;
    bar.classList.toggle('is-stuck', stuck);
    document.documentElement.classList.toggle('bb-pd-stuck', stuck);
  }
  function kick() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick);
  if (header) {
    new MutationObserver(kick).observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
    header.addEventListener('animationend', kick);
    header.addEventListener('transitionend', kick);
  }
  // The Varia sub-bar pins itself (inline style) in its own scroll handler, which can run after ours
  if (variaBar) new MutationObserver(kick).observe(variaBar, { attributes: true, attributeFilter: ['style'] });
  update();

  // Jump to a section, leaving room for everything pinned above it.
  // The theme can interrupt a smooth scroll (sticky header, lazy images changing height),
  // so check again after it settles and finish the move if needed.
  var jumpTimer;
  function jump(id, smooth, tries) {
    var el = document.getElementById(id);
    if (!el) return;
    tries = tries || 0;
    var y = Math.max(0, Math.round(el.getBoundingClientRect().top + window.scrollY - pinnedHeight() - 8));
    window.scrollTo({ top: y, behavior: smooth ? 'smooth' : 'auto' });
    if (!smooth) setTimeout(update, 30);
    clearTimeout(jumpTimer);
    if (tries < 3) {
      jumpTimer = setTimeout(function () {
        var now = Math.round(el.getBoundingClientRect().top + window.scrollY - pinnedHeight() - 8);
        if (Math.abs(window.scrollY - Math.max(0, now)) > 4) jump(id, false, tries + 1);
        else update();
      }, tries ? 300 : 900);
    }
  }
  links.forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var id = a.getAttribute('href').slice(1);
      lockId = id; lockUntil = Date.now() + 1500;
      jump(id, true);
      if (history.replaceState) history.replaceState(null, '', '#' + id);
      setTimeout(function () { a.scrollIntoView({ block: 'nearest', inline: 'center' }); }, 400);
    });
  });
  // "See all details" link in the buy box.
  document.querySelectorAll('a[href="#bb-pd"]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); jump(sections.length ? sections[0].id : 'bb-pd', true); });
  });
  // Arriving with #bb-faq etc. in the URL.
  if (location.hash && /^#bb-/.test(location.hash)) {
    window.addEventListener('load', function () { jump(location.hash.slice(1), false); });
  }

  // The bar's button and price mirror whatever the buy box shows right now. Pre-order apps
  // (Essential Pre-order) hide the theme button and add their own, with their own price,
  // so always use the button/price that is actually visible.
  var add = bar.querySelector('[data-bb-pd-add]');
  var priceEl = bar.querySelector('.bb-pd__buy-price');
  var meta = document.querySelector('.product-single__meta');
  function visibleBuyButton() {
    if (!meta) return null;
    var btns = meta.querySelectorAll('form[action*="/cart/add"] button.add-to-cart, form[action*="/cart/add"] [name="add"]');
    for (var i = 0; i < btns.length; i++) {
      var r = btns[i].getBoundingClientRect();
      var st = window.getComputedStyle(btns[i]);
      if (r.width > 0 && r.height > 0 && r.left > -1000 && st.visibility !== 'hidden' && st.display !== 'none') return btns[i];
    }
    return null;
  }
  function visiblePrice() {
    var block = meta && meta.querySelector('.product-block--price');
    if (!block) return '';
    // The current price element; the block's first line can be a visually-hidden "Regular price" label
    var cur = block.querySelector('[data-product-price]');
    if (cur && cur.textContent.trim()) return cur.textContent.replace(/\s+/g, ' ').trim();
    var first = (block.innerText || '').split('\n').map(function (s) { return s.trim(); }).filter(Boolean)[0];
    return first || '';
  }
  function sync() {
    var b = visibleBuyButton();
    if (add && b) {
      var label = (b.textContent || '').replace(/\s+/g, ' ').trim();
      if (label) add.textContent = label;
      add.disabled = !!b.disabled;
    }
    var p = visiblePrice();
    if (priceEl && p) priceEl.textContent = p;
  }
  if (meta) {
    sync();
    setTimeout(sync, 800);
    setTimeout(sync, 2500); // apps relabel the button after load
    new MutationObserver(function () { clearTimeout(sync.t); sync.t = setTimeout(sync, 60); })
      .observe(meta, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'style', 'class'] });
  }
  if (add) {
    add.addEventListener('click', function () {
      var b = visibleBuyButton();
      if (b && !b.disabled) { b.click(); }
      else { window.scrollTo({ top: 0, behavior: 'smooth' }); }
    });
  }

})();
